import styled from "styled-components";
import { theme } from "../../constants/StyledComponents";

export const StyledFiltersList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top: 24px;
`;

export const StyledFiltersCollapse = styled.div<{ $isLast: boolean }>`
  padding: 22px;
  border-top: 1px solid ${theme.colors.purple_2};
  border-bottom: ${({ $isLast }) =>
    $isLast ? `1px solid ${theme.colors.purple_2}` : "none"};
`;

export const StyledFiltersContent = styled.div`
  padding: 20px;
  border-bottom: 1px solid ${theme.colors.purple_2};

  & .filters-label {
    margin-bottom: 20px;
  }
`;
